import { AffiliateApi } from "@/api/affiliates";
import { UpdateMeRequest } from "@/api/affiliates/types";
import { QueryKey } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useUIStore } from "@/stores";

export const useUpdateMe = () => {
  const queryClient = useQueryClient();
  const { closeModal } = useUIStore();

  const { mutate, isPending } = useMutation({
    mutationFn: (body: UpdateMeRequest) => AffiliateApi.updateMe(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.ME] });
      toast.success("Your bank credentials has been updated successfully.");
    },
    onError: (error: Error) => {
      toast.error(error.message);
    },
    onSettled: () => {
      closeModal();
    },
  });

  return {
    updateMe: mutate,
    isUpdateMeLoading: isPending,
  };
};
